export enum ItemsAndCategoriesAgenda {
    ItemsAndCats = "categories",
    Options = "option-groups",
    Modifiers = "modifiers",
    ModGroups = "modifier-groups",
}

export enum ItemIsActiveFilter {
    Active = "active",
    Inactive = "inactive",
    All = "all",
}

export type ItemsAndCategoriesTableFilters = {
    isActive: ItemIsActiveFilter
}
